import '../../../Styles/AccountPage.css';
import '../../../Styles/ProfileMonetization.css';
import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import MessageBox from '../../../components/MessageBox';
import FormContainer from '../CommonComponents/FormContainer';
import LeftWrapper from '../CommonComponents/LeftWrapper';
import RightWrapper from '../CommonComponents/RightWrapper';
import Wrapper from '../CommonComponents/Wrapper';
import MessageHeading from '../CommonComponents/MessageHeading';
import MessageLabel from '../CommonComponents/MessageLabel';
import MessageSubHeading from '../CommonComponents/MessageSubHeading';
import AdminSaveHeader from '../CommonComponents/AdminSaveHeader';
import { FaInfoCircle } from 'react-icons/fa';
const AdvertiserProfile = () => {

  const access_token = localStorage.getItem("access_token");
  const [accountdata, setAccountData] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [adsPaymentActive, setAdsPaymentActive] = useState(true); // default true until checked
  const [formDataError, setFormDataError] = useState({});
  const [loading, setLoading] = useState(true);
  const [withOutRefresh, setWithOutRefresh] = useState(false);
  const nameRef = useRef();
  const addressRef = useRef();
  const licenseRef = useRef();



  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const formValidation = () => {
    let formIsValid = true;
    if (!accountdata?.company_name) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        company_name: "Name can't be empty",
      }));
      nameRef.current.focus();
      formIsValid = false;
    }
    return formIsValid;
  };

  const handleUpdate = async (e) => {
    if (formValidation()) {
      setLoading(true);
      let formData = new FormData();
      formData.append("company_name", accountdata?.company_name);
      formData.append("email_id", accountdata?.email_id);
      formData.append("license_number", accountdata?.license_number);
      formData.append("ccode", accountdata?.ccode);
      formData.append("mobile_number", accountdata?.mobile_number);
      formData.append("address", accountdata?.address);

      try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/advertiser/account-detail-update`, formData, { headers });
        const result = response?.data
        if (result?.status) {
          toast.success("Account Updated Successfully");
          setWithOutRefresh(!withOutRefresh);
          setLoading(false);
        }
        else { toast.error("Request failed with status: " + response?.status) }
      } catch (error) {
        const errorMessage = error?.response?.data?.message
        toast.error(errorMessage)
        setLoading(false);
      }
    }
  };

  const userDetails = async () => {
    try {
      setLoading(true);

      // Fetch account details and monetization status in parallel
      const [accountRes, monetizationRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_Baseurl}/advertiser/account-detail`, { headers }),
        axios.get(`${process.env.REACT_APP_Baseurl}/advertiser/ads-monetization-status`, { headers })
      ]);

      const result = accountRes?.data?.account_detail;
      setAccountData(result);

      const monetization = monetizationRes?.data?.data || {};
      const adsPaymentStatus = Number(monetization?.ads_payment_status ?? monetization?.status ?? 0);
      setAdsPaymentActive(adsPaymentStatus === 1);

      // Extract subscription data if available
      if (result?.subscription_id) {
        setSubscriptionData({
          subscription_id: result.subscription_id,
          subscription_starts_at: result.subscription_starts_at,
          subscription_ends_at: result.subscription_ends_at,
          payment_type: result.payment_type,
          payment_gateway: result.payment_gateway,
          ads_upload_count_limit: result.ads_upload_count_limit,
          adverister_uploaded_ads_count: result.adverister_uploaded_ads_count,
        });
      } else {
        setSubscriptionData(null);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching account/monetization data", error);
      setLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target
    console.log("event", event.target);
    setAccountData({
      ...accountdata,
      [name]: value,
    });
    setFormDataError((prev) => ({
      ...prev,
      [name]: ""
    }))
  }

  // Helper functions
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getSubscriptionStatus = () => {
    if (!subscriptionData?.subscription_ends_at) return { status: 'inactive', color: 'text-danger' };

    const endDate = new Date(subscriptionData.subscription_ends_at);
    const now = new Date();

    if (endDate > now) {
      return { status: 'active', color: 'text-success' };
    } else {
      return { status: 'expired', color: 'text-warning' };
    }
  };

  const handleStore = async () => {
    if (formValidation()) {
      await handleUpdate();
    }
  };

  useEffect(() => {
    userDetails();
  }, [withOutRefresh]);

  const subscriptionStatus = subscriptionData ? getSubscriptionStatus() : { status: 'inactive', color: 'text-danger' };

  if (loading) {
    return (
      <div className="container-fluid px-2 px-sm-3 px-lg-4 py-2 py-lg-3">
        <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ minHeight: '50vh' }}>
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <h5 className="text-muted mb-2">Loading your profile...</h5>
          <p className="text-muted small mb-0">Please wait while we fetch your account details</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid px-2 px-sm-3 px-lg-4 py-2 py-lg-3">
      {/* Header */}
      <div className="profile-header-container">
        <AdminSaveHeader
          heading="My Account Details"
          saveText="Update Profile"
          saveMethod={handleStore}
        />
      </div>

      <FormContainer className="row g-3 g-lg-4">
        <LeftWrapper className="col-12 col-lg-6">
          <Wrapper className="w-100 mobile-form-section">
            <MessageHeading text="Account Information" />

            {/* Company Name */}
            <MessageLabel text="Company Name" className="mandatorySimple" />
            <input
              type="text"
              name="company_name"
              id="company_namemyprofile"
              ref={nameRef}
              className="profile-form-control mb-3"
              placeholder="Enter company name"
              value={accountdata?.company_name || ''}
              onChange={handleInputChange}
            />
            {formDataError?.company_name && (
              <div className="text-danger mb-3 small">{formDataError.company_name}</div>
            )}

            {/* Email */}
            <MessageLabel text="Email Address" />
            <input
              type="email"
              name="email_id"
              id="emailmyprofile"
              className="profile-form-control mb-3"
              value={accountdata?.email_id || ''}
              disabled={true}
              placeholder="Email address"
            />
            <small className="text-muted mb-3 d-block">Email cannot be changed</small>

            {/* Mobile Number */}
            <MessageLabel text="Mobile Number" />
            <input
              type="text"
              name="mobile_number"
              id="mobilemyprofile"
              className="profile-form-control mb-3"
              value={accountdata?.mobile_number || ''}
              disabled={true}
              placeholder="Mobile number"
            />
            <small className="text-muted mb-3 d-block">Mobile number cannot be changed</small>

            {/* License Number */}
            <MessageLabel text="License Number" />
            <input
              type="text"
              name="license_number"
              id="license_numbermyprofile"
              ref={licenseRef}
              className="profile-form-control mb-3"
              placeholder="Enter license number"
              value={accountdata?.license_number || ''}
              onChange={handleInputChange}
            />
            {formDataError?.license_number && (
              <div className="text-danger mb-3 small">{formDataError.license_number}</div>
            )}

            {/* Address */}
            <MessageLabel text="Address" />
            <textarea
              name="address"
              id="addressmyprofile"
              ref={addressRef}
              className="profile-form-control mb-3"
              placeholder="Enter your address"
              value={accountdata?.address || ''}
              onChange={handleInputChange}
              rows={4}
            />
            {formDataError?.address && (
              <div className="text-danger mb-3 small">{formDataError.address}</div>
            )}
          </Wrapper>
        </LeftWrapper>

        {/* Mobile Section Divider */}
        <div className="mobile-section-divider d-lg-none"></div>

        <RightWrapper className="col-12 col-lg-6">
          {/* Hide Subscription Summary completely when ads monetization is disabled */}
          {adsPaymentActive && (
            <Wrapper className="mobile-subscription-section">
              <MessageHeading text="Subscription Summary" />

              {subscriptionData ? (
                <>
                  {/* Status Indicator */}
                  <div className={`status-indicator ${subscriptionStatus.status === 'active' ? 'enabled' : 'disabled'}`}>
                    <FaInfoCircle className="status-icon" />
                    <div>
                      <MessageSubHeading text="Subscription Status" />
                      <MessageBox
                        text={subscriptionStatus.status.charAt(0).toUpperCase() + subscriptionStatus.status.slice(1)}
                        classname={`fw-bold ${subscriptionStatus.color}`}
                      />
                    </div>
                  </div>

                  {/* Summary Cards */}
                  <div className="summary-grid">
                    <div className="summary-item">
                      <div className="summary-label">Start Date</div>
                      <div className="summary-value theme-color-blue">
                        <span style={{ wordBreak: 'break-word', hyphens: 'auto' }}>
                          {formatDate(subscriptionData.subscription_starts_at)}
                        </span>
                      </div>
                    </div>

                    <div className="summary-item">
                      <div className="summary-label">End Date</div>
                      <div className="summary-value theme-color-green">
                        <span style={{ wordBreak: 'break-word', hyphens: 'auto' }}>
                          {formatDate(subscriptionData.subscription_ends_at)}
                        </span>
                      </div>
                    </div>

                    <div className="summary-item">
                      <div className="summary-label">Payment Gateway</div>
                      <div className="summary-value theme-color-primary">
                        <span style={{ wordBreak: 'break-word', hyphens: 'auto' }}>
                          {"Stripe" || 'N/A'}
                        </span>
                      </div>
                    </div>

                    <div className="summary-item">
                      <div className="summary-label">Payment Type</div>
                      <div className="summary-value theme-color-success">
                        <span style={{ wordBreak: 'break-word', hyphens: 'auto' }}>
                          {"Recuring"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Usage Statistics */}
                  <MessageHeading text="Usage Statistics" />
                  <div className="row g-2 g-md-3">
                    <div className="col-6 col-lg-6">
                      <div className="usage-stat-box">
                        <div className="usage-stat-number blue">
                          {subscriptionData.adverister_uploaded_ads_count || 0}
                        </div>
                        <div className="usage-stat-label">Ads Uploaded</div>
                      </div>
                    </div>

                    <div className="col-6 col-lg-6">
                      <div className="usage-stat-box">
                        <div className="usage-stat-number green">
                          {subscriptionData.ads_upload_count_limit || 0}
                        </div>
                        <div className="usage-stat-label">Upload Limit</div>
                      </div>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <small className="text-muted fw-semibold">Usage Progress</small>
                      <small className="text-muted">
                        {subscriptionData.adverister_uploaded_ads_count || 0} / {subscriptionData.ads_upload_count_limit || 0}
                      </small>
                    </div>
                    <div className="profile-progress">
                      <div
                        className="profile-progress-bar"
                        style={{
                          width: `${subscriptionData.ads_upload_count_limit > 0 ?
                            ((subscriptionData.adverister_uploaded_ads_count || 0) / subscriptionData.ads_upload_count_limit) * 100 : 0}%`
                        }}
                      ></div>
                    </div>
                  </div>

                  {/* Status Validation */}
                  {subscriptionStatus.status === 'active' && (
                    <div className="validation-alert success mt-3">
                      <strong>Active Subscription!</strong> Your subscription is currently active and all features are available.
                    </div>
                  )}

                  {subscriptionStatus.status === 'expired' && (
                    <div className="validation-alert info mt-3">
                      <strong>Subscription Expired!</strong> Please renew your subscription to continue using premium features.
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center py-5">
                  <FaInfoCircle className="text-muted mb-3" size={48} />
                  <MessageSubHeading text="No Active Subscription" />
                  <MessageBox
                    text="Upgrade to a premium plan to unlock advanced features"
                    classname="text-muted mb-3"
                  />
                  {/* Hide Plans link when ads monetization is disabled */}
                  {adsPaymentActive && (
                    <div className="text-center py-5">
                      <a href="/plans" className="profile-btn-primary text-decoration-none">
                        View Plans
                      </a>
                    </div>

                  )}
                </div>
              )}
            </Wrapper>
          )}
        </RightWrapper>
      </FormContainer>
    </div>
  );
};

export default AdvertiserProfile;